<div id="layout">
  <ui-view></ui-view>
</div>
